import { binaryStringToUint8Array } from "../../../shared/utils/binaryString";
import { FILE_TYPE_REGISTRY } from "../constants";
import { TDataFile } from "../types";

export const hasFile = (obj: TDataFile): obj is Required<TDataFile> => {
  return obj.file != null;
};

export const getFileConfig = (filename: string) => {
  const fileExtension =
    filename.split(".").pop()?.toLowerCase() ?? "unsupported";
  const fileConfig = FILE_TYPE_REGISTRY?.[fileExtension]
    ? FILE_TYPE_REGISTRY[fileExtension]
    : FILE_TYPE_REGISTRY.unsupported;
  return fileConfig;
};

export const getMimeTypeFromFileExtensions = (str: string): string => {
  if (str === "pdf") return "application/pdf";
  if (str === "jpg" || str === "jpeg") return "image/jpeg";
  if (str === "png") return "image/png";
  if (str === "xlsx" || str === "docx") return "application/zip";
  if (str === "doc") return "application/msword";
  if (str === "txt") return "text/plain";
  if (str === "csv") return "text/csv";
  if (str === "rtf") return "application/rtf";
  if (str === "json") return "application/json";
  if (str === "xml") return "application/xml";
  if (str === "html" || str === "htm") return "text/html";
  if (str === "md") return "text/markdown";
  return "application/octet-stream";
};

export const downloadFile = (
  binaryString: string,
  mimeType: string,
  filename: string,
) => {
  const uint8Array = binaryStringToUint8Array(binaryString);

  const blob = new Blob([uint8Array as ArrayBuffer], { type: mimeType });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);
};

export const downloadFileWithUrl = (url: string, filename: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  URL.revokeObjectURL(url);
};
